import { render, staticRenderFns } from "./emitente.vue?vue&type=template&id=3374d969"
import script from "./emitente.ts?vue&type=script&lang=js&external"
export * from "./emitente.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3374d969')) {
      api.createRecord('3374d969', component.options)
    } else {
      api.reload('3374d969', component.options)
    }
    module.hot.accept("./emitente.vue?vue&type=template&id=3374d969", function () {
      api.rerender('3374d969', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/importacaonfe/emitente.vue"
export default component.exports